<template>
    <div class="routes">
        <DialogBox ref="resultDialog"></DialogBox>
        <v-dialog v-model="productDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="productDialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Productos de la ruta {{ selectedRouteLabel }}</v-toolbar-title>
                </v-toolbar>
                <ProductsView v-bind:products="products[selectedRouteIndex]"></ProductsView>
            </v-card>
        </v-dialog>
        <v-card id="mapInfo" elevation=12 absolute>
          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-subtitle>Distancia: {{ displayedDistance }} Km</v-list-item-subtitle>
              <v-list-item-subtitle>Tiempo: {{ displayedDuration }} h</v-list-item-subtitle>
            </v-list-item-content>

              <v-select
                  label="Vehiculo"
                  style="width: 20px"
                  v-model="selectedRouteLabel"
                  v-on:change="selectRoutes"
                  :items="vehicleSelectionLabel"
                  prepend-icon="mdi-truck"
              >
              </v-select>
              <v-btn icon @click="productDialog = true" :disabled="selectedRouteLabel==vehicleSelectionLabel[0]">
                  <v-icon>mdi-package</v-icon>
              </v-btn>
          </v-list-item>

        </v-card>
        <OrderDetail @updateDialogShow="updateDialogShow" v-bind:selectedElement="selectedElement" v-bind:dialog="dialog"></OrderDetail>
        <l-map 
            id="routeMap"
            ref="ordersMap"
            :zoom="zoom"
            :center="center"
            :minZoom="minZoom"
            :maxZoom="maxZoom"
            @update:center="centerUpdate"
            @update:zoom="zoomUpdate"
        >
          <l-tile-layer :url="url"></l-tile-layer>

          <l-marker :lat-lng="depot" @click="openProfile()">
            <l-icon
                    :icon-size="dynamicSize"
                    :icon-anchor="dynamicAnchor"
                    icon-url="/img/depotImage.png"
                /> 
          </l-marker>
          <l-marker :lat-lng="currentPosition" @click="openProfile()">
            <l-icon
                    :icon-size="dynamicSize"
                    :icon-anchor="dynamicAnchor"
                    icon-url="/img/currentIcon.png"
                />
          </l-marker>
          <l-marker v-for="order in elements" 
          :key="order.id" 
          :lat-lng="order.location"
          @click="openOrderDetail(order)">>

            <l-icon
              v-if="order.isDelivered"
              class-name="customMarker delivered"
              :icon-size="dynamicSize"
              :icon-url="order.avatar"
            />
            <l-icon
              v-else
              class-name="customMarker notdelivered"
              :icon-size="dynamicSize"
              :icon-url="order.avatar"
            />
          </l-marker>

          <l-polyline v-for="(path, index) in displayedVehiclesPath" :key=index :lat-lngs="path.latlngs" :color="path.color"/>
        </l-map>
        <v-btn v-if="selectedRouteLabel!=vehicleSelectionLabel[0]" @click="openGoogleMaps"
            style="margin-bottom: 50px"
            color="pink"
            dark
            absolute
            bottom
            right
            fab
        >
            <v-icon>mdi-google-maps</v-icon>
        </v-btn>
    </div>
</template>

<script>

/* eslint-disable */
import DialogBox from '../components/DialogBox'
import OrderDetail from '../components/OrderDetail'
import ProductsView from '../components/ProductsView'
import { DB } from '../firebase/db'
import { Auth } from '../firebase/auth'
import * as L from 'leaflet'; 
import { LMap, LTileLayer, LMarker, LPopup, LTooltip, LPolyline, LIcon} from 'vue2-leaflet';
import { getOptimalRoute } from '../routingservice/RoutingService'

// Transforma polyline en array de coordenadas
var polyUtil = require('polyline-encoded');

var moment = require('moment');
moment.locale('es')

export default {
  name: 'routes',
  components: { 
    LMap, 
    LTileLayer,
    LIcon,
    LMarker,
    LPopup,
    LTooltip,
    LPolyline,
    DialogBox,
    OrderDetail,
    ProductsView
  },

  props: ['date'],

  data: () => ({
    // Propiedades del mapa
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      zoom: 13,
      minZoom: 8,
      maxZoom: 17,
      center: [40.962267310600694, -5.6665274472274465],
      bounds: null,
      showParagraph: false,
      map: null,
      nVehicles: 1, // Numero de vehiculos disponibles
      vehicleSelectionLabel: ["Todos"], // lista que se muestra en el desplegable
      selectedRouteLabel: "Todos",
      vehiclesRoutes: [], // Ruta de cada vehículo: [{distante, duration, trip, geometry}] 
      vehiclesPaths: [], // Colección de todas las rutas disponibles
      displayedVehiclesPath: [], // ruta o colección de rutas que se muestra en el mapa
      colors: ['#248ec7', ' #d1607b', '#d18a3f', '#78bf49', '#924bcc', '#bbc94f', "red", "blue", "yellow", "cyan"], // Colores de las distintas posibles rutas
      iconSize: 64,
      orsCurrentPosition : [0,0],
      currentPosition : {lat:0, lng:0},
      depot: {lat:0, lng:0},

      title: "Rutas",
      realtimeUnsub : undefined,
      loading : true,
      elements: [], // lista de orders
      tripInOrder: [],
      dialog: false,
      displayedDistance : 0,
      displayedDuration : 0,
      globalDistance : 0,
      globalDuration : 0,
      selectedElement : {},
      selectedElementIndex: -1,
      products: [],
      productDialog: false,
      selectedRouteIndex: -1
    }),

  created() {
    this.$emit('updateTitle', this.title);
    this.getOrders();
  }, 
  watch : {
    date : function(date) {
      this.getOrders();
    }
  },
  computed: {
    // Establece de forma dinámica el tamaño de los markers
    // de forma inversamente proporcional al zoom
    dynamicSize() {
      let zoomNormalizado = 1-(this.zoom/this.maxZoom);
      let reduction = 6;
      let scale = (1 / zoomNormalizado ) / reduction;
      
      if (scale > 1.4)
        scale = 1.10;

      return [this.iconSize*scale, this.iconSize*scale];
    },
    dynamicAnchor() {
      return [10, 10];
    }
  },
  methods: {
    // Map Methods
    clearPath(element) {
      this.displayedVehiclesPath = [];
    },
    selectRoutes(selection) {

        if(selection !== "Todos") {
            this.selectedRouteIndex = Number.parseInt(selection) - 1
        }
        console.log(this.products)
        if ( selection==this.vehicleSelectionLabel[0] ) {
        // Se añaden a la vista todas las rutas
            this.displayedVehiclesPath = this.vehiclesPaths;

            this.tripInOrder = []
            this.vehiclesRoutes.forEach((r)=> {
                r.trip.forEach((t)=> {
                    this.tripInOrder.push(t);
                });
            }); 

        this.displayedDistance = this.globalDistance;
        this.displayedDuration = this.globalDuration;
      } else {
        // Se añade la seleccionada
        this.displayedVehiclesPath = [];
        this.displayedVehiclesPath.push(this.vehiclesPaths[selection - 1]);

        this.tripInOrder = this.vehiclesRoutes[selection-1].trip;

        try {
          this.displayedDistance = (this.vehiclesRoutes[selection-1].distance / 1000).toFixed(2);
          this.displayedDuration = (this.vehiclesRoutes[selection-1].duration / 3600).toFixed(2);
        } catch (err) {
          console.log(err)
          this.displayedDistance = 0;
          this.displayedDuration = 0;
        }
      }

      const bounds = this.tripInOrder.map( pos => Object.values(pos.location) );
      this.setBounds(bounds);
    },

    setBounds(coordinateGroup) {
      this.$nextTick(() => {
        this.map = this.$refs.ordersMap.mapObject;
        this.map.fitBounds(coordinateGroup);
      });
    },

    async updatePath(depotPosition) { 
      const positions = [depotPosition]
      this.elements.forEach(order => {
        positions.push(Object.values(order.location));
      })
      if(positions.length > 1) {
          if(this.routesRealtimeUnsub != undefined){
            this.routesRealtimeUnsub();
          }
            // Obtenemos las rutas de la base de datos
            this.routersRealtimeUnsub = DB.collection('routes').doc(this.date)
            .onSnapshot( snapshot => {
                const response = snapshot.data();
                this.displayedDistance = (response.distance / 1000).toFixed(2);
                this.displayedDuration = (response.duration / 3600).toFixed(2);
                this.globalDistance = (response.distance / 1000).toFixed(2);
                this.globalDuration = (response.duration / 3600).toFixed(2);

                this.vehiclesPaths = [];

                this.vehiclesRoutes = response.routes;

                this.vehicleSelectionLabel = ["Todos"];

                this.vehiclesRoutes.forEach((r, i)=>{
                    this.vehicleSelectionLabel.push(i+1);

                    this.vehiclesPaths.push({
                    latlngs: polyUtil.decode(r.geometry),
                    color: this.colors[i]
                    });
                });

                this.displayedVehiclesPath = this.vehiclesPaths;

                this.tripInOrder = []
                this.vehiclesRoutes.forEach((r)=> {
                    this.products.push([])
                    r.trip.forEach((t)=> {
                        let tripElement = {...t}
                        let order = this.elements.find( value => {
                            return value.id == t.id
                        })
                        if(order) {
                            this.products[this.products.length - 1].push(order.products)
                            this.products[this.products.length - 1] = [].concat.apply([], this.products[this.products.length - 1])
                            tripElement.isDelivered = order.isDelivered
                        }
                        this.tripInOrder.push(tripElement);
                    });
                    console.log(this.tripInOrder)
                const bounds = this.tripInOrder.map( pos => Object.values(pos.location) );
                this.setBounds(bounds);
                })
            })
        }
        else {
            this.displayedDistance = 0;
            this.displayedDuration = 0;
            this.vehiclesRoutes = [];
            this.vehiclesPaths = [];
            this.displayedVehiclesPath = [];
            this.tripInOrder = [];
            this.products = [];
        }
    },

    // Metodos utilizados mapa para actualizar propiedades
    zoomUpdate (zoom) {
      this.zoom = zoom;
    },
    centerUpdate (center) {
      this.center = center;
    },
    boundsUpdated (bounds) {
      this.bounds = bounds;
    },
    showLongText() {
      this.showParagraph = !this.showParagraph;
    },
    innerClick() {
      alert("Click!");
    },
    // A partir de la lista de pedidos existente, calcula el centro respecto a todos (media)
    centerMap() {
      var lat = 0, lng = 0, i = 0;

      this.elements.forEach( order => {
        lat += order.location.lat;
        lng += order.location.lng;
        i++;
      });

      if(i != 0) {
        lat = lat / i;
        lng = lng / i;
        this.centerUpdate([lat, lng]);
      }
    },
    openOrderDetail(order) {
      this.selectedElement = order;
      this.dialog = true;
    },
    openProfile(){
        this.$router.push('/profile')
    },
    // Abre la ruta en google maps
    async openGoogleMaps() {
      let baseString = 'https://www.google.com/maps/dir';

      if(this.elements.length > 0) {
        const position = await this.getCurrentPos();
        const waypointsLeft = this.getWaypointsLeft(position);
        waypointsLeft.forEach( point => {
          baseString += '/' + point[0] + ',' + point[1];
        })
        baseString += '/data=!3m1!4b1!4m2!4m1!3e0'
        window.location.href = baseString;
      }
      else {
        this.$refs.resultDialog.show('error', 'No existen suficientes destinos en el mapa para crear una ruta', false);
      }
    },
    // Se obtienen los pedidos y se procesa los datos para que puedan ser utilizados correctamente
    getOrders () {

      if(this.ordersRealtimeUnsub != undefined){
        this.ordersRealtimeUnsub();
      }

      this.elements.splice(0);

      this.ordersRealtimeUnsub = DB.collection('orders').where('date', '==', this.date)
        .onSnapshot( snapshots => {

          snapshots.docChanges().forEach( change => {

            const item = change.doc;
            let element = {
              formattedDate : moment(item.data().date).format("DD-MM-YYYY"),
              date : item.data().date,
              isDelivered : item.data().isDelivered,
              user : item.data().user,
              products : item.data().products,
              firebaseId: item.id,
              id : item.data().id,
              location: item.data().location,
              orsLocation: [item.data().location.lng, item.data().location.lat], // formateado para ors 
              avatar: item.data().userPhoto,
              address: item.data().address,
              fromVoiceAssistant: item.data().fromVoiceAssistant
            }
            
            switch (change.type) {
              case "added":
                this.elements.push(element); 
                break;

              case "modified":
                for (let i = 0; i < this.elements.length; i++) {
                  if(this.elements[i].id == item.id)
                  {
                    this.elements[i] = { ...element }
                    break;
                  }
                }
                break;

              case "removed":
                for (let i = 0; i < this.elements.length; i++) {
                  if(this.elements[i].id == item.id)
                  {
                    this.elements.splice(i, 1);
                    break;
                  }
                }
                break;
            }

          })

          DB.collection('users').doc(Auth.currentUser.uid).get()
          .then( snapshot => {
            const location = snapshot.data().location;
            this.nVehicles = snapshot.data().vehicles;

            this.depot = {...location}
            this.centerMap();
            this.updatePath(Object.values(location));
          })
          .catch(error => {
            this.$refs.resultDialog.show('error', "Es necesario conocer la localizacion de su almacen. Vaya a 'Perfil' para definirlo.", false);
          });

          this.getCurrentPos().then( currentPosition => {
            this.currentPosition = currentPosition
          })

          this.loading = false;
        })
    },

    updateDialogShow(show) {
      this.dialog = show;
    },

    getWaypointsLeft(currentPosition) {
        const waypointsLeft = []
        waypointsLeft.push(currentPosition)
        this.tripInOrder.forEach((position, index) => {
            if(index != 0 && (position.id == -1 || !position.isDelivered)) {
                waypointsLeft.push(position.location)
            }
        })

      return waypointsLeft;
    },

    getCurrentPos() {
      return new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition( 
          position => {
            const currentPosition = [ position.coords.latitude, position.coords.longitude ];
            resolve(currentPosition);
          },
          error => {
            reject(error);
          }
        )
      })
    }
  }
}

</script>

<style>

.customMarker {
  padding: 3px;
  border: 1px solid #333;
  border-radius: 0 50% 50% 50%;
  box-shadow: 5px 3px 10px rgba(0, 0, 0, 0.2);
  text-align: center;
  max-width: 65px;
  max-height: 65px;
  margin: 0 !important;
}

.delivered {
  background-color: #2D8F1A;
}

.notdelivered {
   background-color: #d89c2f;
}


.v-select {
  margin-right: 1em;
}
</style>